import { createForm } from '@seek/forms-ui';
import { Box, Stack } from 'braid-design-system';
import { useState } from 'react';

import { Form } from './components/Form/Form';
import { ThanksView } from './components/ThanksView/ThanksView';

const FORM_NAME = 'integration-request-form';
const TrackingProps = {
  page: 'integration-request',
  siteSection: 'partners',
};

interface EnquiryFormValues {
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  phone: string;
  company: string;
  companyUrl: string;
  partnerType: string[];
  seekRsp: 'yes' | 'no';
  recruitmentSoftware?: string;
  customerSegment?: string;
  numCustomers?: string;
  largestCustomers?: Array<{ seekId: string; name: string }>;
  integrateToSeek?: 'yes' | 'no';
  reasonForIntegration?: string;
  currentlyIntegrated: 'yes' | 'no';
  solutions: string[];
  whySeek: string;
  reviewDocs: boolean;
}

export type FormValues = EnquiryFormValues & Record<string, unknown>;

const { FormProvider, useField } = createForm<FormValues>(FORM_NAME);
export { useField };

export const EnquiryForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const initialValues: FormValues = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    phone: '',
    email: '',
    company: '',
    companyUrl: '',
    partnerType: [],
    seekRsp: 'yes',
    recruitmentSoftware: '',
    customerSegment: '',
    numCustomers: '0',
    largestCustomers: [],
    integrateToSeek: 'yes',
    reasonForIntegration: '',
    currentlyIntegrated: 'yes',
    solutions: [],
    whySeek: '',
    reviewDocs: false,
  };

  return (
    <Box>
      <Box>
        {submitted ? (
          <ThanksView setSubmitted={setSubmitted} /> //eslint-disable-line
        ) : (
          <Stack space="xlarge">
            <FormProvider initialValues={initialValues}>
              {({ handleSubmit, resetForm, setFieldValue }) => (
                <Form
                  handleSubmit={handleSubmit}
                  setSubmitted={setSubmitted}
                  setFieldValue={setFieldValue}
                  resetForm={resetForm}
                  trackingProps={TrackingProps}
                />
              )}
            </FormProvider>
          </Stack>
        )}
      </Box>
    </Box>
  );
};
